(() => {
  const setText = (root, selector, value) => {
    root.querySelectorAll(selector).forEach(node => { node.textContent = value || ''; });
  };
  const paintPrice = (root, data) => {
    setText(root, '[data-price]', data.price);
    setText(root, '[data-original]', data.total);
    root.querySelectorAll('[data-promotion]').forEach(node => { node.hidden = !data.promo; });
  };
  if (!customElements.get('lola-set-card')) customElements.define('lola-set-card', class extends HTMLElement {
    connectedCallback() {
      const config = this.querySelector('[data-set-config]');
      if (!config) return;
      const data = JSON.parse(config.textContent);
      paintPrice(this, data);
      if (!data.available && !this.querySelector('.ls-card-unavailable')) {
        const note = document.createElement('div');
        note.className = 'ls-card-unavailable';
        note.textContent = this.dataset.soldOut;
        this.querySelector('.innerer').appendChild(note);
      }
    }
  });
  if (!customElements.get('lola-pearl-set')) customElements.define('lola-pearl-set', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) { this.setupStickyPurchase(); return; }
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-set-config]').textContent);
      this.button = this.querySelector('[data-add-button]');
      this.quantities = Object.fromEntries(Object.values(this.config)[0].items.map(item => [item.key, 1]));
      this.coreVariants = {};
      this.extraVariants = {};
      this.busy = false;
      const requestedFinish = new URL(window.location.href).searchParams.get('finish');
      this.finish = Object.prototype.hasOwnProperty.call(this.config, requestedFinish) ? requestedFinish : Object.keys(this.config)[0];
      this.querySelectorAll('.ls-finishes input[type=radio]').forEach(input => {
        input.checked = input.value === this.finish;
        input.addEventListener('change', () => {
          this.finish = input.value;
          this.coreVariants = {};
          // Finish changes clear optional additions so a hidden metal is never purchased.
          this.extraVariants = {};
          Object.keys(this.quantities).filter(key => key.startsWith('extra-')).forEach(key => { delete this.quantities[key]; });
          const url = new URL(window.location.href);
          url.searchParams.set('finish', this.finish);
          window.history.replaceState({}, '', url);
          this.resetFeedback();
          this.render();
        });
      });
      this.querySelectorAll('[data-quantity]').forEach(input => {
        input.addEventListener('input', () => {
          if (input.value !== '' && Number.isInteger(Number(input.value))) {
            this.setQuantity(input.dataset.quantity, input.value);
          }
        });
        input.addEventListener('change', () => this.setQuantity(input.dataset.quantity, input.value));
      });
      this.querySelectorAll('[data-quantity-step]').forEach(button => {
        button.addEventListener('click', () => {
          this.setQuantity(button.dataset.key, (this.quantities[button.dataset.key] || 0) + Number(button.dataset.quantityStep));
          if (button.dataset.key.startsWith('extra-') && !this.quantities[button.dataset.key]) {
            button.closest('[data-extra-picker]').querySelector('summary').focus({ preventScroll: true });
          }
        });
      });
      this.querySelectorAll('[data-extra-variant]').forEach(select => {
        select.addEventListener('change', () => this.selectExtra(select.dataset.extraVariant, select.value));
      });
      this.querySelectorAll('[data-remove-extra]').forEach(button => {
        button.addEventListener('click', () => {
          this.selectExtra(button.dataset.removeExtra, '');
          button.closest('[data-extra-picker]').querySelector('summary').focus({ preventScroll: true });
        });
      });
      this.querySelectorAll('[data-core-variant]').forEach(select => {
        select.addEventListener('change', () => this.selectCore(select.dataset.coreVariant, select.value));
      });
      this.querySelectorAll('[data-core-size]').forEach(input => {
        input.addEventListener('change', () => this.selectCore(input.dataset.coreSize, input.value));
      });
      this.querySelectorAll('[data-toggle-item]').forEach(button => {
        button.addEventListener('click', () => {
          const key = button.dataset.toggleItem;
          this.setQuantity(key, this.quantities[key] > 0 ? 0 : 1);
        });
      });
      this.querySelectorAll('[data-customize-toggle]').forEach(button => {
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          this.dataset.customizing = String(expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.closeLabel : button.dataset.openLabel;
          this.querySelectorAll('[data-customize-hint]').forEach(node => {
            node.hidden = !expanded;
          });
          this.syncComponentControls();
        });
      });
      this.querySelectorAll('.ls-item-details').forEach(details => {
        details.addEventListener('toggle', () => this.syncComponentControls());
      });
      this.syncComponentControls();
      const guideDialog = this.querySelector('[data-size-dialog]');
      if (guideDialog) {
        this.querySelectorAll('[data-size-guide]').forEach(button => {
          button.addEventListener('click', () => {
            guideDialog.querySelectorAll('[data-guide-content]').forEach(content => {
              content.hidden = content.dataset.guideContent !== button.dataset.sizeGuide;
              if (!content.hidden) setText(guideDialog, '[data-guide-title]', content.dataset.title);
            });
            guideDialog.showModal();
            document.documentElement.classList.add('ls-guide-open');
          });
        });
        guideDialog.querySelector('[data-close-guide]').addEventListener('click', () => guideDialog.close());
        guideDialog.addEventListener('click', event => {
          if (event.target !== guideDialog) return;
          const box = guideDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) guideDialog.close();
        });
        guideDialog.addEventListener('close', () => document.documentElement.classList.remove('ls-guide-open'));
      }
      this.button.addEventListener('click', () => this.add());
      this.querySelector('[data-sticky-add]')?.addEventListener('click', () => this.add());
      this.setupStickyPurchase();
      this.querySelectorAll('[data-add-selection]').forEach(button => button.addEventListener('click', () => this.add()));
      this.render();
    }
    syncComponentControls() {
      const editingAll = this.dataset.customizing === 'true';
      this.querySelectorAll('[data-component-row]').forEach(row => {
        const details = row.querySelector('.ls-item-details');
        const controls = row.querySelector('.ls-component-controls');
        const inlineHost = row.querySelector('[data-inline-quantity-host]');
        if (!details || !controls || !inlineHost) return;
        // Move the same control; quantities, listeners and labels never have duplicates.
        const host = editingAll ? row : inlineHost;
        if (controls.parentElement !== host) host.appendChild(controls);
        controls.classList.toggle('ls-component-controls--inline', !editingAll);
        controls.hidden = !editingAll && !details.open;
      });
    }
    setupStickyPurchase() {
      const bar = this.querySelector('[data-sticky-purchase]');
      if (!bar || !('IntersectionObserver' in window)) return;
      this.stickyMedia = window.matchMedia('(max-width: 767px)');
      let pastButton = false;
      let atFooter = false;
      this.updateSticky = () => { bar.hidden = !this.stickyMedia.matches || !pastButton || atFooter; };
      this.stickyMedia.addEventListener('change', this.updateSticky);
      this.stickyObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === this.button) pastButton = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          else atFooter = entry.isIntersecting;
        }
        this.updateSticky();
      });
      this.stickyObserver.observe(this.button);
      const footer = document.querySelector('#pagefooter');
      if (footer) this.stickyObserver.observe(footer);
    }
    disconnectedCallback() {
      this.stickyObserver?.disconnect();
      this.stickyMedia?.removeEventListener('change', this.updateSticky);
    }
    resetFeedback() {
      this.querySelector('[data-error-message]').hidden = true;
      this.querySelector('[data-error-cart]').hidden = true;
      this.querySelector('[data-selection-status]').hidden = true;
    }
    setQuantity(key, value) {
      if (this.busy) return;
      const item = this.allItems().find(entry => entry.key === key);
      if (!item) return;
      const number = Number(value);
      this.quantities[key] = Math.max(0, Math.min(item.max, Number.isFinite(number) ? Math.floor(number) : 0));
      if (key.startsWith('extra-') && this.quantities[key] === 0) delete this.extraVariants[key];
      this.resetFeedback();
      this.render();
    }
    selectExtra(key, id) {
      if (this.busy) return;
      const extra = (this.config[this.finish].extras || []).find(item => item.key === key);
      const variant = extra && extra.variants.find(item => String(item.id) === String(id) && item.available && item.max > 0);
      if (variant) {
        this.extraVariants[key] = variant.id;
        this.quantities[key] = Math.min(this.quantities[key] || 1, variant.max);
      } else {
        delete this.extraVariants[key];
        this.quantities[key] = 0;
      }
      this.resetFeedback();
      this.render();
    }
    selectCore(key, id) {
      if (this.busy) return;
      const item = this.config[this.finish].items.find(item => item.key === key);
      const variant = item && (item.variants || []).find(variant => String(variant.id) === String(id) && variant.available && variant.max > 0);
      if (variant) {
        this.coreVariants[key] = variant.id;
        this.quantities[key] = Math.min(this.quantities[key] || 1, variant.max);
      } else {
        delete this.coreVariants[key];
      }
      this.resetFeedback();
      this.render();
    }
    allItems() {
      const data = this.config[this.finish];
      const core = data.items.map(item => {
        if (!item.requiresSelection) return item;
        const variant = (item.variants || []).find(variant => variant.id === this.coreVariants[item.key]);
        return variant ? { ...item, ...variant } : { ...item, id: null };
      });
      return core.concat((data.extras || []).flatMap(extra => {
        const variant = extra.variants.find(item => item.id === this.extraVariants[extra.key]);
        return variant ? [variant] : [];
      }));
    }
    selection() {
      const data = this.config[this.finish];
      const items = this.allItems().map(item => ({ ...item, quantity: this.quantities[item.key] || 0 })).filter(item => item.quantity > 0);
      const total = items.reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);
      const eligiblePrices = items.filter(item => item.eligible).flatMap(item => Array(item.quantity).fill(item.unitPrice)).sort((a, b) => a - b);
      // This store's active Buy 2 Get 1 rule has no per-order usage limit.
      const promoActive = data.promo && Date.now() <= Date.parse(data.promoEnd);
      const freeCount = promoActive ? Math.floor(eligiblePrices.length / 3) : 0;
      const saving = eligiblePrices.slice(0, freeCount).reduce((sum, price) => sum + price, 0);
      return { items, total, price: total - saving, promo: saving > 0, valid: items.length > 0 && items.every(item => item.id && item.available && item.quantity <= item.max) };
    }
    render() {
      const data = this.config[this.finish];
      const selection = this.selection();
      const money = new Intl.NumberFormat(document.documentElement.lang || 'he', { style: 'currency', currency: data.currency || 'ILS' });
      paintPrice(this, { price: money.format(selection.price / 100), total: money.format(selection.total / 100), promo: selection.promo });
      const promoDetails = this.querySelector('[data-promo-details]');
      if (promoDetails) promoDetails.hidden = !data.promo || Date.now() > Date.parse(data.promoEnd);
      const image = this.querySelector('[data-set-image]');
      if (image.getAttribute('src') !== data.image) image.src = data.image;
      image.alt = this.finish === 'gold' ? image.dataset.altGold : image.dataset.altSilver;
      this.querySelectorAll('[data-component-material]').forEach(node => {
        node.textContent = this.finish === 'gold' ? this.dataset.materialGold : this.dataset.materialSilver;
      });
      this.allItems().filter(item => !item.key.startsWith('extra-')).forEach(item => {
        const select = this.querySelector(`[data-core-variant="${item.key}"]`);
        if (select) {
          select.value = this.coreVariants[item.key] ? String(this.coreVariants[item.key]) : '';
          select.disabled = this.busy;
          select.required = this.quantities[item.key] > 0;
          setText(this, '[data-core-size-summary]', item.size ? `מידה ${item.size}` : 'בחירת מידה');
        }
        const omitted = this.quantities[item.key] === 0;
        const itemState = this.querySelector(`[data-item-state="${item.key}"]`);
        if (itemState) {
          const quantity = this.quantities[item.key] || 0;
          itemState.textContent = omitted ? this.dataset.omittedLabel : quantity > 1 ? `× ${quantity}` : '';
          itemState.hidden = !omitted && quantity === 1;
        }
        if (item.key === 'ring') setText(this, '[data-ring-size-summary]', item.id && !omitted ? `${this.dataset.sizeLabel} ${item.size}` : '');
        const sizeGroup = this.querySelector(`[data-core-size-choice="${item.key}"]`);
        if (sizeGroup) {
          sizeGroup.hidden = omitted;
          this.querySelectorAll(`[data-core-size="${item.key}"]`).forEach(input => {
            const variant = (item.variants || []).find(variant => String(variant.id) === input.value);
            input.checked = String(this.coreVariants[item.key] || '') === input.value;
            input.disabled = this.busy || omitted || !variant || !variant.available || variant.max < 1;
            input.required = !omitted;
          });
          const feedback = sizeGroup.querySelector('[data-core-size-feedback]');
          if (item.id || omitted) delete sizeGroup.dataset.needsSelection;
          const needsAttention = sizeGroup.dataset.needsSelection === 'true';
          feedback.textContent = item.id ? `${this.dataset.sizeSelected} ${item.size}` : (needsAttention ? this.dataset.sizeAction : '');
          sizeGroup.querySelector('[role="radiogroup"]').setAttribute('aria-invalid', String(needsAttention));
          feedback.dataset.selected = String(Boolean(item.id));
          feedback.hidden = !feedback.textContent;
        }
        const toggle = this.querySelector(`[data-toggle-item="${item.key}"]`);
        if (toggle) {
          const action = omitted ? this.dataset.restore : this.dataset.remove;
          toggle.textContent = action;
          toggle.setAttribute('aria-label', `${action}: ${toggle.dataset.itemName}`);
          toggle.disabled = this.busy || (omitted && item.max < 1);
        }
        const link = this.querySelector(`[data-component="${item.key}"]`);
        if (link && item.url) link.href = item.url;
        const input = this.querySelector(`[data-quantity="${item.key}"]`);
        input.value = this.quantities[item.key];
        input.max = item.max;
        input.disabled = this.busy;
        input.setAttribute('aria-invalid', String(this.quantities[item.key] > item.max));
        this.querySelector(`[data-component-row="${item.key}"]`).dataset.omitted = String(this.quantities[item.key] === 0);
        this.querySelectorAll(`[data-quantity-step][data-key="${item.key}"]`).forEach(button => {
          button.disabled = this.busy || (Number(button.dataset.quantityStep) < 0 ? this.quantities[item.key] <= 0 : this.quantities[item.key] >= item.max);
        });
      });
      this.querySelectorAll('.ls-finishes input[type=radio]').forEach(input => { input.disabled = this.busy; });
      this.renderExtras(selection, money);
      const needsSize = selection.items.some(item => item.requiresSelection && !item.id);
      this.button.disabled = this.busy || (!selection.valid && !needsSize);
      this.button.textContent = this.busy ? this.dataset.adding : this.dataset.add;
      const stickyButton = this.querySelector('[data-sticky-add]');
      if (stickyButton) {
        stickyButton.disabled = this.button.disabled;
        stickyButton.textContent = this.button.textContent;
      }
      if (selection.items.length && !selection.valid && !needsSize) {
        const status = this.querySelector('[data-selection-status]');
        status.textContent = needsSize ? this.dataset.chooseRing : this.dataset.unavailable;
        status.hidden = false;
      }
    }
    renderExtras(selection, money) {
      const data = this.config[this.finish];
      this.querySelectorAll('[data-extras-finish]').forEach(panel => {
        panel.hidden = panel.dataset.extrasFinish !== this.finish;
        panel.querySelectorAll('[data-extra-variant]').forEach(select => { select.disabled = this.busy || panel.hidden; });
      });
      const panel = this.querySelector(`[data-extras-finish="${this.finish}"]`);
      if (!panel) return;
      (data.extras || []).forEach(extra => {
        const card = panel.querySelector(`[data-extra-card="${extra.key}"]`);
        if (!card) return;
        const chosen = extra.variants.find(item => item.id === this.extraVariants[extra.key]);
        const shown = chosen || extra.variants.find(item => item.available);
        if (shown) {
          let descriptions = {};
          try {
            const parsed = JSON.parse(card.querySelector('[data-extra-description-map]').textContent);
            descriptions = typeof parsed === 'string' ? JSON.parse(parsed) : parsed || {};
          } catch (_) { /* Older products may have no variant description map. */ }
          const matchingKey = Object.keys(descriptions).find(key => key.split('||')[0] === shown.metal);
          let description = descriptions[shown.descriptionKey] || descriptions[matchingKey] || card.querySelector('[data-extra-description-fallback]').content.textContent;
          // Some multi-finish products only store a silver base description.
          if (shown.metal === 'ציפוי זהב') description = description.replace(/בציפוי רודיום/g, 'בציפוי זהב');
          setText(card, '[data-extra-description]', description.replace(/[–—]/g, '-').trim());
        }
        card.querySelector('[data-extra-variant]').value = chosen ? String(chosen.id) : '';
        card.querySelector('[data-extra-selection]').hidden = !chosen;
        const quantity = this.quantities[extra.key] || 0;
        const picker = card.querySelector('[data-extra-picker]');
        if (picker) {
          picker.dataset.selected = String(Boolean(chosen));
          const option = card.querySelector('[data-extra-variant]').selectedOptions[0];
          setText(picker, '[data-extra-picker-label]', chosen ? picker.dataset.selectedLabel : picker.dataset.chooseLabel);
          const choice = picker.querySelector('[data-extra-picker-choice]');
          if (choice) {
            choice.textContent = chosen ? `${option.textContent} × ${quantity}` : '';
            choice.hidden = !chosen;
          }
        }
        const remove = card.querySelector('[data-remove-extra]');
        if (remove) remove.disabled = this.busy || !chosen;
        const input = card.querySelector('[data-quantity]');
        input.value = quantity;
        input.max = chosen ? chosen.max : 0;
        input.disabled = this.busy || !chosen;
        card.querySelectorAll('[data-quantity-step]').forEach(button => {
          button.disabled = this.busy || !chosen || (Number(button.dataset.quantityStep) < 0 ? quantity <= 0 : quantity >= chosen.max);
        });
        if (shown) {
          setText(card, '[data-extra-price]', money.format(shown.unitPrice / 100));
          card.querySelectorAll('[data-extra-link]').forEach(link => { link.href = shown.url; });
          const image = card.querySelector('[data-extra-image]');
          if (image.getAttribute('src') !== shown.image) image.src = shown.image;
        }
      });
      const extras = selection.items.filter(item => item.key.startsWith('extra-'));
      this.querySelector('[data-extras-checkout]').hidden = !extras.length;
      setText(this, '[data-selection-total]', money.format(selection.price / 100));
      setText(this, '[data-extra-summary]', extras.map(item => {
        const card = panel.querySelector(`[data-extra-card="${item.key}"]`);
        return `${card.querySelector('.product-block__title').textContent} × ${item.quantity}`;
      }).join(' · '));
      const needsSize = selection.items.some(item => item.requiresSelection && !item.id);
      this.querySelectorAll('[data-add-selection]').forEach(button => {
        button.disabled = this.busy || (!selection.valid && !needsSize);
        if (!button.dataset.readyText) button.dataset.readyText = button.textContent;
        button.textContent = this.busy ? this.dataset.adding : button.dataset.readyText;
      });
    }
    async add() {
      if (this.busy || this.button.disabled) return;
      const selection = this.selection();
      if (!selection.valid) {
        const missing = selection.items.find(item => item.requiresSelection && !item.id);
        if (missing) {
          const group = this.querySelector(`[data-core-size-choice="${missing.key}"]`);
          if (group) {
            group.dataset.needsSelection = 'true';
            this.render();
            group.scrollIntoView({ block: 'center', behavior: 'auto' });
            group.focus({ preventScroll: true });
          }
        }
        return;
      }
      this.busy = true;
      this.resetFeedback();
      this.render();
      const sections = ['page-header', 'cart-drawer'].map(selector => document.querySelector(selector)).filter(node => node && node.dataset.sectionId);
      let added = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: selection.items.map(item => ({ id: item.id, quantity: item.quantity })), sections: sections.map(node => node.dataset.sectionId), sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items)) throw new Error('Set could not be added');
        added = true;
        this.busy = false;
        this.render();
        // Use the same server-rendered sections and drawer methods as the theme's buy-buttons.
        const complete = sections.length && sections.every(node => result.sections && typeof result.sections[node.dataset.sectionId] === 'string' && typeof node.updateFromCartChange === 'function');
        if (complete) sections.forEach(node => node.updateFromCartChange(result.sections[node.dataset.sectionId]));
        else this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(this.button);
        else this.querySelector('[data-error-cart]').hidden = false;
        const status = this.querySelector('[data-selection-status]');
        status.textContent = this.dataset.added;
        status.hidden = false;
        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: selection.items[0].id, items: selection.items.map(item => ({ id: item.id, quantity: item.quantity })) } }));
      } catch (_) {
        // Never retry a cart mutation automatically: a response failure can still add items.
        this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        const error = this.querySelector('[data-error-message]');
        error.textContent = added ? this.dataset.added : this.dataset.error;
        error.hidden = false;
        this.querySelector('[data-error-cart]').hidden = false;
      } finally {
        this.busy = false;
        this.render();
      }
    }
  });
})();
